import React from 'react';
import {
  SIN_IDENTIFICAR, estiloMarca, marcaDe, nombreMarca as nombreEn, useMarcas,
} from '../lib/marcas';

/**
 * De qué marca viene un lead (dirección, 26/09/2026): «que quede claro cuál
 * viene de uno y del otro».
 *
 * Quién decide la marca es el servidor (services/marca_lead.py, UNA función);
 * aquí solo se pinta. Las marcas —su nombre y su color— son las de la clínica
 * (Configuración → Marcas, GET /api/marcas): aquí no hay ninguna escrita. Lo
 * que no se sabe sale como «Sin identificar», con borde discontinuo y sin
 * color de ninguna: no se reparte.
 */
export { SIN_IDENTIFICAR };

/**
 * Las pestañas de la lista: «Todos» y cada marca PROPIA (dirección,
 * 30/09/2026: «arriba tenemos que poner todos, [las dos marcas]. Tienen que
 * quedar esos tres»). Las procedencias externas y lo que sale «Sin
 * identificar» no tienen pestaña, pero no se pierden: están en «Todos» y
 * cada fila lleva su etiqueta. Qué marca es propia lo dice la base
 * (`externa`), no esta pantalla.
 */
export function pestanasMarca(marcas) {
  return [
    { clave: 'todos', nombre: 'Todos' },
    ...(marcas || []).filter((m) => !m.externa).map((m) => ({ clave: m.clave, nombre: m.nombre })),
  ];
}

export function nombreMarca(marcas, clave) {
  return nombreEn(marcas, clave);
}

const SIN = 'bg-transparent text-muted-foreground border-dashed border-gray-400';

/**
 * La etiqueta. Con `onClick` es un botón (abre la ficha del lead); sin él,
 * una etiqueta quieta. `inline-flex` a propósito: así el tachado de la fila de
 * un contactado no la atraviesa y la marca se sigue leyendo. `marcas`, si ya
 * las tiene quien la pinta; si no, las pide (una vez para toda la pantalla).
 */
export default function MarcaLead({ marca, onClick, testid, title, className = '', marcas }) {
  const pedidas = useMarcas();
  const lista = marcas || pedidas;
  const m = marcaDe(lista, marca);
  const estilo = m ? estiloMarca(m) : null;
  const clase = `inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5
    text-xs font-medium no-underline ${m ? '' : SIN} ${onClick ? 'hover:opacity-80 cursor-pointer' : ''} ${className}`;
  const contenido = (
    <>
      <span aria-hidden="true" className={`w-1.5 h-1.5 rounded-full ${m ? '' : 'bg-gray-300'}`}
        style={estilo?.punto} />
      {m ? m.nombre : SIN_IDENTIFICAR}
    </>
  );
  const clave = m ? m.clave : 'sin';
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={clase} style={estilo?.chip}
        data-testid={testid} data-marca={clave} title={title}>
        {contenido}
      </button>
    );
  }
  return (
    <span className={clase} style={estilo?.chip} data-testid={testid} data-marca={clave} title={title}>
      {contenido}
    </span>
  );
}
